import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const Hero = () => {
  return (
    <section className="flex flex-wrap justify-end md:flex-nowrap lg:justify-between">
      <div className="flex flex-col justify-center text-right mb-10 lg:mb-0 lg:w-[40%] xl:w-[40%] 2xl:mr-[132px]">
        <h1 className="font-playfair text-[70px] text-black font-black mb-3 md:w-11/12 xl:w-auto">
          Anna Portfold
        </h1>
        <span className="text-black font-ubuntu font-light text-[16px] md:w-11/12 xl:w-auto">
          landscapes
          <br />
          portraits
          <br />
          studio
        </span>
      </div>

      <div className="lg:w-[53%] xl:w-auto 2xl:w-1/2">
        <StaticImage
          className="xl:w-[650px]"
          src="../../images/hero-image.webp"
          width={650}
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="hero image"
        />
      </div>
    </section>
  )
}

export default Hero
